import _ from 'lodash';
import styled from 'styled-components';
import { GRAPH_STACKING_TYPES, GRAPH_VIEWS } from '../../Graph/graph.views';
import Icon from 'components/base/Icon';
import { LBTabs, LBTabsList, LBTabsTrigger } from '@linearb/buzz';

const StyledGraphStackingToggler = styled.div`
  margin-right: 1rem;
`;

const GraphStackingToggler = ({ graphView }) => {
  const stackingTypes = _.filter(
    GRAPH_STACKING_TYPES,
    ({ isToggleable }) => isToggleable
  );

  if (graphView.viewType === GRAPH_VIEWS.PERCENT) return null;

  return (
    <StyledGraphStackingToggler>
      <LBTabs
        value={graphView.stackingType.key}
        onValueChange={stackingTypeKey =>
          graphView.setStackingType(GRAPH_STACKING_TYPES[stackingTypeKey])
        }
      >
        <LBTabsList>
          {_.map(stackingTypes, currType => {
            const isSelected = graphView.stackingType.key === currType.key;
            const iconColor = isSelected ? 'white' : 'shuttleGray';

            return (
              <LBTabsTrigger key={currType.key} value={currType.key}>
                <Icon name={currType.icon} color={iconColor} />
              </LBTabsTrigger>
            );
          })}
        </LBTabsList>
      </LBTabs>
    </StyledGraphStackingToggler>
  );
};

export default GraphStackingToggler;
